var MessageCenterWindowType = {
    All: 1,
    Alert:  2,
    SharedItems : 3,
    PanarayMessages : 4
 }
 export default MessageCenterWindowType;